/**
 * A markdown pipe table as headers and rows, the same rule as `parse_md_table` in
 * `backend/services/markdown_tables.py` (the eCTD PDF and the Word file read that one), so a table
 * the PDF prints as a table is a table on the page too. `mdTable.test.ts` and
 * `tests/test_dossier_results_parity.py` hold the same cases.
 */

// A markdown table's second line: | --- | :---: | ---: |
const RULE_RE = /^\|?\s*:?-{3,}:?\s*(?:\|\s*:?-{3,}:?\s*)*\|?$/;

function cellsOf(line: string): string[] {
  return line
    .trim()
    .replace(/^\|+|\|+$/g, '')
    .split('|')
    .map((cell) => cell.trim());
}

export interface MdTable {
  headers: string[];
  rows: string[][];
}

/**
 * The lines (a run of lines that start with a pipe) as a table, or null when they are not one.
 * A table whose `---` rule line the model left out still counts when all its lines have the same
 * two or more cells; the first line is then the header.
 */
export function parseMdTable(lines: string[]): MdTable | null {
  const [head, second] = lines;
  if (head === undefined || second === undefined) return null;
  let body: string[];
  if (RULE_RE.test(second.trim())) {
    body = lines.slice(2);
  } else {
    const widths = new Set(lines.map((line) => cellsOf(line).length));
    const [width] = widths;
    if (widths.size !== 1 || width === undefined || width < 2) return null;
    body = lines.slice(1);
  }
  return { headers: cellsOf(head), rows: body.map(cellsOf) };
}
